import type { AdInterface } from "types/ad";

/**
 * Human-readable service location for an ad (structured fields, then client fallbacks).
 */
export function formatAdServiceLocation(ad: AdInterface, fullAddress: boolean = false): string {
    const streetLine = [ad.house_number, ad.street].filter(Boolean).join(", ").trim();
    const postalLine = [ad.postcode, ad.city].filter(Boolean).join(" ").trim();

    if (fullAddress) {
        if (postalLine) {
            return streetLine ? `${streetLine} ${postalLine}` : postalLine;
        }
    }
    else {
        if (ad.city || ad.postcode) {
            return ad.city
                ? (ad.postcode ? `${ad.city} (${ad.postcode})` : ad.city)
                : String(ad.postcode);
        }
    }

    const clientAddress = ad.client.address?.trim();
    if (clientAddress) {
        return clientAddress;
    }

    return ad.client.postcode ? `${ad.client.city} (${ad.client.postcode})` : ad.client.city;
}
